// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2edaca6c]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.site-color-picker[data-v-2edaca6c]{border:.5px solid hsla(0,0%,100%,.3);border-radius:2px;height:33px;margin-bottom:16px;position:relative;width:100%}.visibility-hidden_picker[data-v-2edaca6c]{left:-18px;pointer-events:auto;position:absolute;top:0;z-index:2000}.visibility-hidden_picker[data-v-2edaca6c] .vc-sketch-field{color:rgba(0,0,0,.85)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
